// Kept out of the 'use client' notice module: server components import it to read the cookie, and
// a value exported from a client module reaches them as a client reference, not the string.
/** Cookie every app reads server-side to decide whether to render `TermsOfUseNotice`. */
export const TERMS_OF_USE_COOKIE = 'morpho-terms-accepted'

/** Window event fired when the notice is accepted, for UI that waits on the consent wall. */
export const TERMS_OF_USE_ACCEPTED_EVENT = 'morpho-terms-accepted'

const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365

/** Records acceptance for one year, using Secure on HTTPS so local HTTP development keeps working. */
export function setTermsOfUseAcceptedCookie(): void {
  const secure = location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${TERMS_OF_USE_COOKIE}=true; path=/; max-age=${COOKIE_MAX_AGE_SECONDS}; SameSite=Lax${secure}`
}
